import React from "react";
import clsx from "clsx";

interface Props {
    className?:string
}

const ChevroneIcon:React.FC<Props> = ({className}) => {
    return (
        <svg className={clsx("svg-icon", className)} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M26 12L16 22L6 12" stroke="#E0E8E0" strokeWidth="3" strokeLinecap="round"
                  strokeLinejoin="round"
            />
        </svg>
    )
}

export default ChevroneIcon